export default [
  {
    path: "/chat-assignment",
    name: "chat-assignment",
    component: () => import("@/views/chatAssignment/View.vue"),
    meta: {
      pageTitle: "breadcrumb.chatAssignment",
      navActiveLink: "chat-assignment",
      resource: "chat-settings",
      action: "read",
      breadcrumb: [
        {
          text: "breadcrumb.chatAssignment",
          active: true,
        },
      ],
    },
  },
];
``;
